'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _forgotPasswordForm = require('./forgot-password-form');

var _forgotPasswordForm2 = _interopRequireDefault(_forgotPasswordForm);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _ref = _jsx('br', {});

var ForgotPasswordModal = _react2['default'].createClass({
    displayName: 'ForgotPasswordModal',


    propTypes: {
        'tabOffset': _react2['default'].PropTypes.number,
        'recoverPasswordForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
        'emailAddress': _react2['default'].PropTypes.string
    },

    getInitialState: function getInitialState() {
        return {};
    },

    componentDidMount: function componentDidMount() {
        $(document).foundation();
        $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
    },

    render: function render() {

        var form = _jsx(_forgotPasswordForm2['default'], {
            tabOffset: this.props.tabOffset,
            method: 'POST',
            namespace: this.props.recoverPasswordForm.namespace,
            action: _hfReactHelper2['default'].urlHelper('account/recoverPassword', _hfReactHelper2['default'].HfSites.SITE_CODE_HS),
            fields: this.props.recoverPasswordForm.fields,
            values: this.props.recoverPasswordForm.values,
            emailAddress: this.props.emailAddress,
            errors: { 'global': this.state.error }
        });

        return _jsx('div', {
            className: 'row text-center'
        }, void 0, _jsx('div', {
            className: 'columns small-12'
        }, void 0, _jsx('h4', {}, void 0, 'No worries.'), _jsx('p', {
            className: 'l-padding-b-10'
        }, void 0, 'Enter your email address to request a password reset.', _ref), form));
    }
});

module.exports = ForgotPasswordModal;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/forgot-password-modal.jsx
 ** module id = 754
 ** module chunks = 0
 **/